import { TinyChart, iTinyChart, Ring, iRing, Square } from './charts'
import { Card } from './molecules'
import React from 'react'

const COLORS = ['#d15637', '#0fd447', 'deepskyblue', '#8884d8']


export const EngagementRate = ({ data }: iTinyChart) => <Card title="Engagement Rate">
    <nav className="level">
        <div className="level-item" style={{maxWidth: 210, minWidth: 210, margin:'auto'}}>
            <TinyChart data={data}/>
        </div>

        <div className="level-item level-engagement">
            <p className="subtitle is-3" style={{color: 'white', marginBottom: 20}}> 
                <small style={{fontSize: '1rem'}}>Avg</small><br/>
                { Math.round((data.reduce((d, { Engagement }) => d+=Engagement, 0)/data.length)*10)/10 } <small>%</small>
            </p>
        </div>

        <div className="level-item level-engagement">
            <p className="subtitle is-3" style={{color: 'white', marginBottom: 20}}> 
                <small style={{fontSize: '1rem'}}>High</small> <br/>
                { Math.round(Math.max(...data.map(({ Engagement }) => Engagement))*10)/10 } <small>%</small>
             </p>
        </div>
    </nav>
</Card>


export const TweetCounter = ({ tweets, replies }: { tweets: number, replies: number }) => <Card title="Tweet Counter">
    <nav className="level" style={{marginBottom: 0, padding: 0}}>
        <div className="level-item" style={{display:'inline-flex', width: '50%'}}>
            <p style={{color: 'white'}}> 
                <small> Tweets </small> <br/>
                <span className="subtitle is-2" style={{color: 'deepskyblue'}}> { Math.round(tweets) } </span> 
            </p>
        </div>
        <div className="level-item" style={{display:'inline-flex', width: '50%'}}>
            <p style={{color:'white'}}> 
                <small> Replies </small> <br/>
                <span className="subtitle is-2" style={{color: 'white'}}> { Math.round(replies) } </span>
            </p>
        </div>
    </nav>
</Card>


interface iImpressions { tweets: number, total: number, isWeekly?: boolean }
export const Impressions = ({ tweets, total, isWeekly=false }: iImpressions) => <Card title={ !isWeekly ? 'Impressions' : 'Total Impressions' }>
    <nav className="level" style={{marginBottom: 0, padding: 0}}>
        <div className="level-item" style={{display:'inline-flex', width: '50%'}}>
            <p style={{color: 'white'}}> 
                <small> { !isWeekly ? 'Tweets' : 'Average' } </small> <br/>
                <span className="subtitle is-2" style={{color: 'goldenrod'}}> 
                    { Math.round(tweets).toLocaleString() } 
                </span> 
            </p>
        </div>

        <div className="level-item" style={{display:'inline-flex', width: '50%'}}>
            <p style={{color:'white'}}> 
                <small> { !isWeekly ? 'Tweets & Replies' : 'High' } </small> <br/>
                <span className="subtitle is-2" style={{color: 'white'}}> 
                    { Math.round(total).toLocaleString() } 
                </span>
            </p>
        </div>
    </nav>
</Card>


const ENGAGEMENT_STYLE = {color:'white', display:'inline-table', minWidth:24, textAlign:'right', marginRight:8 } as const
export const EngagementRing = ({ data }: iRing) => <Card title="Engagements">
    <nav className="level" style={{marginBottom: 0, padding: 0}}>
        <div className="level-item">
            <Ring data={data}/>
        </div>
        <div className="level-item">
            <p style={{color:'white', textAlign: 'left'}}> 
                <Square color={COLORS[0]}/> 
                    <strong style={ENGAGEMENT_STYLE}> { data.find(({ name }) => name === 'Likes')?.value } </strong> 
                    Likes <br/>
                <Square color={COLORS[1]}/> 
                <strong style={ENGAGEMENT_STYLE}> { data.find(({ name }) => name === 'Retweets')?.value } </strong> 
                    Retweets <br/>
                <Square color={COLORS[2]}/> 
                <strong style={ENGAGEMENT_STYLE}> { data.find(({ name }) => name === 'Replies')?.value } </strong> 
                    Replies <br/>
                <Square color={COLORS[3]}/> 
                <strong style={ENGAGEMENT_STYLE}> { data.find(({ name }) => name === 'Visits')?.value } </strong> 
                    Profile Visits
            </p>
        </div>
    </nav>
</Card>
